/* eslint-disable no-restricted-imports */
import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ModalProgressBar } from '../../../../../_metronic/_partials/controls';
import * as actions from '../../_redux/sales/salesActions';
import { useSalesUIContext } from '../SalesUIContext';

export function SaleDeleteDialog({ id, show, onHide }) {
  // Sales UI Context
  //console.log("SaleDeleteDialog", id);
  const salesUIContext = useSalesUIContext();
  const salesUIProps = useMemo(() => {
    return {
      setIds: salesUIContext.setIds,
      queryParams: salesUIContext.queryParams,
    };
  }, [salesUIContext]);
  //const [show, setShow] = useState(false);

  // Sales Redux state
  const dispatch = useDispatch();
  const intl = useIntl();
  const titleText = intl.formatMessage({ id: 'SALES.CONFIRM.TITLE' });
  const questionText = intl.formatMessage({
    id: 'SALES.CONFIRM.DELETE.QUESTION',
  });
  const deleteButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.DELETE',
  });
  const cancelButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.CANCEL',
  });
  const loadingText = intl.formatMessage({
    id: 'SALES.CONFIRM.DELETE.LOADING',
  });
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.sales ? state.sales.actionsLoading : false,
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    /*  if(match){
      setShow( true);
    } */
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSale = () => {
    // server request for deleting sale by id
    dispatch(actions.deleteSale(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSales(salesUIProps.queryParams));
      // closing delete modal
      // clear selections list
      //salesUIProps.setIds([]);
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      {isLoading && <ModalProgressBar variant='query' />}
      <Modal.Header closeButton>
        <Modal.Title id='Saleexample-modal-sizes-title-lg'>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>
            {' '}
            <b>{id}</b> {questionText}
          </span>
        )}
        {isLoading && <span>{loadingText}</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'
          >
            {cancelButtonText}
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteSale}
            className='btn btn-primary btn-elevate'
          >
            {deleteButtonText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
